import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_USER_MUTATION } from '../graphql/mutations'
import { DELETE_USER } from '../redux/action-types'

const useDeleteUserMutation = () => {
  const dispatch = useDispatch()

  const { isLoading, error, idToDelete } = useSelector(
    store => store.users.users,
  )

  const mutate = useCallback(
    id =>
      apolloService.mutate(DELETE_USER_MUTATION, { id }, dispatch, DELETE_USER),
    [dispatch],
  )

  return [mutate, { isLoading, error, idToDelete }]
}

export default useDeleteUserMutation
